<div class="component validation-summary-example">
    <h2>Validation summary</h2>
    <sbw-validation-summary [errorList]="errors"></sbw-validation-summary>
</div>